import classNames from "classnames";
import React, { FC, ReactNode } from "react";

type Props = {
  cardName: string;
  cardCounts: ReactNode;
  isActive: boolean;
  isLoading?: boolean;
  isError?: boolean;
};

export const StatsCard: FC<Props> = ({
  cardName,
  cardCounts,
  isActive,
  isLoading = false,
  isError = false,
}) => {
  return (
    <div
      className={classNames(
        "outline flex h-[110px] w-full flex-col justify-center rounded-[10px] bg-white px-5 py-4 outline-1 outline-gray-300 max-md:px-3",
        isActive ? "border-b-[2px] border-[#7C66F0]" : "",
      )}>
      {isLoading ? (
        <>
          <div
            className={"mx-auto h-9 w-12 animate-pulse rounded bg-gray-200"}
          />
          <div
            className={classNames(
              "flex justify-center font-Manrope text-sm font-semibold",
              isActive ? "text-purple" : "text-[#2B333C]",
            )}>
            {cardName}
          </div>
        </>
      ) : (
        <>
          <div
            className={classNames(
              "flex justify-center font-Manrope text-[24px] font-semibold max-md:text-[20px]",
              isActive ? "text-purple" : "text-[#2B333C]",
            )}>
            {isError ? "—" : cardCounts}
          </div>

          <div
            className={classNames(
              "flex justify-center font-Manrope text-sm font-semibold",
              isActive ? "text-purple" : "text-[#2B333C]",
            )}>
            {cardName}
          </div>
        </>
      )}
    </div>
  );
};
